import { render } from "./Error.vue?vue&type=template&id=2fc640e9&ts=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__